import RequestCreator from './helpers/requestCreator';

export interface SpaceEvaluationModel {
  id?: string;
  eventId: string;
  spaceId: string;
  rating: number;
  comment?: string | null;
}

class SpaceEvaluations extends RequestCreator<SpaceEvaluationModel> {
  getByEventId = async (eventId: string) => {
    try {
      const result = await this.api.get<{ data: SpaceEvaluationModel[] }>(`${this.path}`, {
        params: { eventId },
      });
      return result.data;
    } catch (error) {
      throw error;
    }
  };
}

const api = new SpaceEvaluations('/space-evaluations');
export default api;
